import { render, staticRenderFns } from "./SpinnerLoading.vue?vue&type=template&id=45206675"
import script from "./SpinnerLoading.vue?vue&type=script&lang=js"
export * from "./SpinnerLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports